import { computeTaxCharges, type LocationLike } from '@fv/client-core'
import type { ChargeName, Currency } from '@fv/models'

export function buildSpotQuoteCharges(
  currency: Currency,
  baseAmount: number,
  locations: LocationLike[],
): Array<{ name: ChargeName; amount: number }> | undefined {
  const taxes = computeTaxCharges(currency, baseAmount, locations)
  if (!taxes.length) return undefined
  return [{ name: 'linehaul', amount: baseAmount }, ...taxes]
}
